<div class="delete-dialog__backdrop">
  <div class="delete-dialog">
    <h2 class="delete-dialog__title">{{ title }}</h2>
    <p class="delete-dialog__message">{{ message }}</p>

    <div class="delete-dialog__actions">
      <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">
        {{ cancelLabel }}
      </button>
      <button type="button" class="btn btn-danger" (click)="onDelete()">
        {{ confirmLabel }}
      </button>
    </div>
  </div>
</div>
